import React from "react";
import { lazy } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import BarraNavegacion from "./Componentes/barraNavegacion";
import GlobalSnackbar from "./Componentes/GlobalSnackbar";
import ClaveSeguraDialog from "./Componentes/ClaveSeguraDialog";
import Login from "./Login/Login";
import Home from "./Home/Home";

import AltaTrabajador from "./Samsic/altaTrabajador";


const NuevoParte = lazy(() => import('./Partes/NuevoParte'));

const PartesDeTrabajo = lazy(() => import('./Partes/PartesDeTrabajo'));
const PartesDeTrabajoOrdenables = lazy(() => import('./Partes/PartesDeTrabajoOrdenables'));
const DetalleParte = lazy(() => import('./Partes/DetalleParte'));
const ReasignarCliente = lazy(() => import('./Partes/ReasignarCliente'));

const Clientes = lazy(() => import('./Clientes/Clientes'));
const DetalleCliente = lazy(() => import('./Clientes/DetalleCliente'));

const Tablets = lazy(() => import('./Tablets/Tablets'));
const DetalleTablet = lazy(() => import('./Tablets/DetalleTablet'));

// const Revisiones = lazy(() => import('./Revisiones/Revisiones'));
// const DetalleRevision = lazy(() => import('./Revisiones/DetalleRevision'));

// const PartesAutomaticos = lazy(() => import('./PartesAutomaticos/PartesAutomaticos'));
// const EdicionParteAutomatico = lazy(() => import('./PartesAutomaticos/EdicionParteAutomatico'));

const Dispositivos = lazy(() => import('./Dispositivos/Dispositivos'));
const DetalleDispositivo = lazy(() => import('./Dispositivos/DetalleDispositivo'));
const NuevoDispositivo = lazy(() => import('./Dispositivos/NuevoDispositivo'));

// const PlantillasDispositivo = lazy(() => import('./PlantillasDispositivo/PlantillasDispositivo'));

const GLPI = lazy(() => import('./GLPI/GLPI'));
const DetalleGLPI = lazy(() => import('./GLPI/DetalleGLPI'));

// const MonitoringAlarms = lazy(() => import('./Monitoring/MonitoringAlarms'));
const Dashboard = lazy(() => import('./Dashboard/Dashboard'));
const MonitoringActiveBackup = lazy(() => import('./Monitoring/MonitoringActiveBackup'));
const MonitoringMikrotik = lazy(() => import('./Monitoring/MonitoringMikrotik'));
const MikrotikDetalle = lazy(() => import('./Monitoring/MikrotikDetalle'));

const ServiciosExternos = lazy(() => import('./Utilidades/ServiciosExternos'));
// const AutoRespondedor = lazy(() => import('./Utilidades/AutoRespondedor')); // Retirado
const ConsultarMAC = lazy(() => import('./Utilidades/mac'));
const Bitacora = lazy(() => import('./Utilidades/Bitacora'));
const ClaveSegura = lazy(() => import('./Utilidades/ClaveSegura'));
const EnviarSMS = lazy(() => import('./Utilidades/EnviarSMS'));
// const CorreoPlesk = lazy(() => import('./Utilidades/CorreoPlesk')); // Retirado
const Facturacion = lazy(() => import('./Utilidades/Facturacion'));
const IpLocate = lazy(() => import('./Utilidades/IpLocate'));
const TopTen = lazy(() => import('./Utilidades/TopTen'));
const EstadisticaTaller = lazy(() => import('./Utilidades/EstadisticaTaller'));
const EtiquetaPostal = lazy(() => import('./Utilidades/EtiquetaPostal'));
const Tarjetas = lazy(() => import('./Utilidades/Tarjetas'));
const CreacionTarjeta = lazy(() => import('./Samsic/CreacionTarjeta'));
const Backups = lazy(() => import('./Utilidades/Backups'));
const Software = lazy(() => import('./Utilidades/Software'));
const Protocolos = lazy(() => import('./Utilidades/Protocolos'));
const DetalleProtocolo = lazy(() => import('./Utilidades/DetalleProtocolo'));
const ProgramadorPartes = lazy(() => import('./Utilidades/ProgramadorPartes'));
const EstadoFortinet = lazy(() => import('./Utilidades/EstadoFortinet'));
const ClaveSeguridad = lazy(() => import('./Utilidades/ClaveSeguridad'));
const Tareas = lazy(() => import('./Utilidades/Tareas'));
const Nomenclaturas = lazy(() => import('./Utilidades/Nomenclaturas'));

const ConsultaParte = lazy(() => import('./ZonaPublica/consultaParte'));
const SolicitudTarjetas = lazy(() => import('./ZonaPublica/SolicitudTarjetas'));
const FirmaSamsicPublica = lazy(() => import('./ZonaPublica/FirmaSamsicPublica'));
const EstadisticasFortinet = lazy(() => import('./ZonaPublica/Estadisticas/EstadisticasFortinet'));
const Formularios = lazy(() => import('./ZonaPublica/Formularios/Formularios'));

const IA = lazy(() => import('./IA/IA'));

const PS = lazy(() => import('./PS/PS'));
const PSGLPI = lazy(() => import('./PS/GLPI'));
const VpnL2tp = lazy(() => import('./PS/VpnL2tp'));
const VpnSSTP = lazy(() => import('./PS/VpnSSTP'));
const CertificadoSSTP = lazy(() => import('./PS/CertificadoSSTP'));
const CertificadoPersonal = lazy(() => import('./PS/CertificadoPersonal'));
const ActiveBackup = lazy(() => import('./PS/ActiveBackup'));

const FTTH = lazy(() => import('./Telco/FTTH'));
const SIP = lazy(() => import('./Telco/SIP'));
const EndpointTelco = lazy(() => import('./Telco/Endpoint'));
const Fortinet = lazy(() => import('./Telco/Fortinet'));
const ServidoresTelco = lazy(() => import('./Telco/Servidores'));

const ApiFortinet = lazy(() => import('./Api/Fortinet'));
const ApiOvh = lazy(() => import('./Api/Ovh'));
const ApiDmi = lazy(() => import('./Api/DMI'));
const ApiPlesk = lazy(() => import('./Api/Plesk'));

const ConfiguracionCorreo = lazy(() => import('./ZonaPublica/Manuales/ConfiguracionCorreo'));
const SincronizarSharepoint = lazy(() => import('./ZonaPublica/Manuales/SincronizarSharepoint'));
const Autorespondedor365 = lazy(() => import('./ZonaPublica/Manuales/Autorespondedor365'));
const ConfiguracionFortiClient74 = lazy(() => import('./ZonaPublica/Manuales/ConfiguracionFortiClient74'));

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <BarraNavegacion onLogout={handleLogout} />
      <div style={{ marginTop: "20px" }}>{children}</div>
    </>
  );
};

const AppRoutes = () => {

  return (
    <Router>
      <GlobalSnackbar />
      <ClaveSeguraDialog />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/SamsicIberia/5c27c6f2-bb04-4512-a3e5-1c47b3cee17e" element={<AltaTrabajador />} />
        <Route path="/ZonaPublica/consultaParte/:uuid" element={<ConsultaParte />} />
        <Route path="/ZonaPublica/solicitudTarjetas/e677f1a8-9683-4ca1-9c14-e889feb66682" element={<SolicitudTarjetas />} />
        <Route path="/ZonaPublica/samsic/9f3a1b7c-4d28-4e6a-b1f0-7c5e2a9d84b6" element={<FirmaSamsicPublica />} />
        <Route path="/ZonaPublica/formularios/:uuid" element={<Formularios />} />
        <Route path="/ZonaPublica/Estadisticas/Fortinet/:uuid" element={<EstadisticasFortinet />} />

        <Route path="/ZonaPublica/Manuales/ConfiguracionCorreo" element={<ConfiguracionCorreo />}
        />

        <Route path="/ZonaPublica/Manuales/SincronizarSharepoint" element={<SincronizarSharepoint />}
        />

        <Route path="/ZonaPublica/Manuales/Autorespondedor365" element={<Autorespondedor365 />}
        />

        <Route path="/ZonaPublica/Manuales/ConfiguracionFortiClient7.4" element={<ConfiguracionFortiClient74 />}
        />

        {
          /*************************************
          Rutas protegidas
          *************************************/
        }
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Clientes"
          element={
            <ProtectedRoute>
              <Clientes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Clientes/:id"
          element={
            <ProtectedRoute>
              <DetalleCliente />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Tablets"
          element={
            <ProtectedRoute>
              <Tablets />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Tablets/:id"
          element={
            <ProtectedRoute>
              <DetalleTablet />
            </ProtectedRoute>
          }
        />

        {/* <Route
          path="/Revisiones"
          element={
            <ProtectedRoute>
              <Revisiones />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Revisiones/:id"
          element={
            <ProtectedRoute>
              <DetalleRevision />
            </ProtectedRoute>
          }
        /> */}

        {/* <Route
          path="/PartesAutomaticos"
          element={
            <ProtectedRoute>
              <PartesAutomaticos />
            </ProtectedRoute>
          }
        /> */}

        {/* <Route
          path="/PartesAutomaticos/Editar/:id"
          element={
            <ProtectedRoute>
              <EdicionParteAutomatico />
            </ProtectedRoute>
          }
        /> */}

        <Route
          path="/Partes"
          element={
            <ProtectedRoute>
              <PartesDeTrabajo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Partes/Ordenables"
          element={
            <ProtectedRoute>
              <PartesDeTrabajoOrdenables />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Partes/NuevoParte"
          element={
            <ProtectedRoute>
              <NuevoParte />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Partes/DetalleParte/:id"
          element={
            <ProtectedRoute>
              <DetalleParte />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Partes/ReasignarCliente/:id"
          element={
            <ProtectedRoute>
              <ReasignarCliente />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Dispositivos"
          element={
            <ProtectedRoute>
              <Dispositivos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Dispositivos/DetalleDispositivo/:id"
          element={
            <ProtectedRoute>
              <DetalleDispositivo />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Dispositivos/NuevoDispositivo"
          element={
            <ProtectedRoute>
              <NuevoDispositivo />
            </ProtectedRoute>
          }
        />

        {/* <Route path="/PlantillasDispositivo"
          element={
            <ProtectedRoute>
              <PlantillasDispositivo />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/GLPI"
          element={
            <ProtectedRoute>
              <GLPI />
            </ProtectedRoute>
          }
        />
        <Route
          path="/GLPI/:id"
          element={
            <ProtectedRoute>
              <DetalleGLPI />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/Monitoring"
          element={
            <ProtectedRoute>
              <Monitoring />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/dashBoard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Integracion/ActiveBackup"
          element={
            <ProtectedRoute>
              <MonitoringActiveBackup />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Integracion/Mikrotik"
          element={
            <ProtectedRoute>
              <MonitoringMikrotik />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Integracion/Mikrotik/:id"
          element={
            <ProtectedRoute>
              <MikrotikDetalle />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/Monitoring/Alarms"
          element={
            <ProtectedRoute>
              <MonitoringAlarms />
            </ProtectedRoute>
          }
        /> */}

        <Route
          path="/Utilidades/ServiciosExternos"
          element={
            <ProtectedRoute>
              <ServiciosExternos />
            </ProtectedRoute>
          }
        />

        {/* AutoRespondedor retirado — la gestión se hace desde IA / Acciones rápidas
        <Route
          path="/Utilidades/AutoRespondedor"
          element={
            <ProtectedRoute>
              <AutoRespondedor />
            </ProtectedRoute>
          }
        />
        */}

        <Route
          path="/Utilidades/mac"
          element={
            <ProtectedRoute>
              <ConsultarMAC />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Utilidades/IpLocate"
          element={
            <ProtectedRoute>
              <IpLocate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Utilidades/Bitacora"
          element={
            <ProtectedRoute>
              <Bitacora />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Utilidades/ClaveSegura"
          element={
            <ProtectedRoute>
              <ClaveSegura />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Utilidades/EnviarSMS"
          element={
            <ProtectedRoute>
              <EnviarSMS />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Utilidades/TopTen"
          element={
            <ProtectedRoute>
              <TopTen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Utilidades/EstadisticaTaller"
          element={
            <ProtectedRoute>
              <EstadisticaTaller />
            </ProtectedRoute>
          }
        />
        {/* CorreoPlesk retirado — la gestión de correo se hace desde IA / Acciones rápidas
        <Route
          path="/Utilidades/CorreoPlesk"
          element={
            <ProtectedRoute>
              <CorreoPlesk />
            </ProtectedRoute>
          }
        />
        */}

        <Route
          path="/Utilidades/Facturacion"
          element={
            <ProtectedRoute>
              <Facturacion />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Utilidades/EtiquetaPostal"
          element={
            <ProtectedRoute>
              <EtiquetaPostal />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Utilidades/Tarjetas"
          element={
            <ProtectedRoute>
              <Tarjetas />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Samsic/CreacionTarjeta"
          element={
            <ProtectedRoute>
              <CreacionTarjeta />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Utilidades/Backups"
          element={
            <ProtectedRoute>
              <Backups />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Utilidades/Tareas"
          element={
            <ProtectedRoute>
              <Tareas />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Utilidades/Software"
          element={
            <ProtectedRoute>
              <Software />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Utilidades/Protocolos"
          element={
            <ProtectedRoute>
              <Protocolos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Utilidades/Protocolos/:id"
          element={
            <ProtectedRoute>
              <DetalleProtocolo />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Utilidades/Nomenclaturas"
          element={
            <ProtectedRoute>
              <Nomenclaturas />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Utilidades/ProgramadorPartes"
          element={
            <ProtectedRoute>
              <ProgramadorPartes />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Utilidades/EstadoFortinet"
          element={
            <ProtectedRoute>
              <EstadoFortinet />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Utilidades/ClaveSeguridad"
          element={
            <ProtectedRoute>
              <ClaveSeguridad />
            </ProtectedRoute>
          }
        />

        <Route
          path="/PS"
          element={
            <ProtectedRoute>
              <PS />
            </ProtectedRoute>
          }
        />
        <Route
          path="/PS/GLPI"
          element={
            <ProtectedRoute>
              <PSGLPI />
            </ProtectedRoute>
          }
        />
        <Route
          path="/PS/VpnL2tp"
          element={
            <ProtectedRoute>
              <VpnL2tp />
            </ProtectedRoute>
          }
        />
        <Route
          path="/PS/VpnSSTP"
          element={
            <ProtectedRoute>
              <VpnSSTP />
            </ProtectedRoute>
          }
        />
        <Route
          path="/PS/CertificadoSSTP"
          element={
            <ProtectedRoute>
              <CertificadoSSTP />
            </ProtectedRoute>
          }
        />
        <Route
          path="/PS/CertificadoPersonal"
          element={
            <ProtectedRoute>
              <CertificadoPersonal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/PS/ActiveBackup"
          element={
            <ProtectedRoute>
              <ActiveBackup />
            </ProtectedRoute>
          }
        />
        <Route
          path="/IA"
          element={
            <ProtectedRoute>
              <IA />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Telco/FTTH"
          element={
            <ProtectedRoute>
              <FTTH />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Telco/SIP"
          element={
            <ProtectedRoute>
              <SIP />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Telco/Endpoint"
          element={
            <ProtectedRoute>
              <EndpointTelco />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Telco/Fortinet"
          element={
            <ProtectedRoute>
              <Fortinet />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Telco/Servidores"
          element={
            <ProtectedRoute>
              <ServidoresTelco />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Integracion/Fortinet"
          element={
            <ProtectedRoute>
              <ApiFortinet />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Integracion/OVH"
          element={
            <ProtectedRoute>
              <ApiOvh />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Integracion/DMI"
          element={
            <ProtectedRoute>
              <ApiDmi />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Integracion/Plesk"
          element={
            <ProtectedRoute>
              <ApiPlesk />
            </ProtectedRoute>
          }
        />

      </Routes>

    </Router>
  );
};

export default AppRoutes;
